module.exports = __webpack_public_path__ + "18536a6830a4256acbc572294527099e.png";